import { KeyboardDateTimePicker } from '@material-ui/pickers';
import { useField } from 'react-final-form';
import React from 'react';
import moment from 'moment';
import { Text as TextField } from '../..';
export const DateTimeField = ({ label, name, validate, minDate, minDateMessage, maxDate, maxDateMessage, helperText, }) => {
    const { meta: { invalid }, input: { value, onChange }, } = useField(name, { validate: validate });
    const momentValue = value ? moment(moment.utc(value).valueOf()) : null;
    const handleChange = (date, value) => {
        if (date) {
            onChange(date
                .clone()
                .utc()
                .format());
        }
        else {
            onChange(date);
        }
    };
    return (React.createElement(KeyboardDateTimePicker, { value: momentValue, onChange: handleChange, error: invalid, label: label, minDate: minDate, minDateMessage: minDateMessage, maxDate: maxDate, maxDateMessage: maxDateMessage, TextFieldComponent: TextField, inputVariant: "filled", format: "MM/DD/YYYY hh:mm a", helperText: helperText }));
};
//# sourceMappingURL=DateTimeField.js.map